export default function EventExpertise() {
  const expertise = [
    {
      id: 1,
      icon: 'ri-team-line',
      title: 'Corporate Meetings & Ice Breakers',
      description: 'High-energy starts for professional meetings that break down barriers and energize your team from the first moment.'
    },
    {
      id: 2,
      icon: 'ri-goblet-line',
      title: 'Gala Dinners',
      description: 'One-of-a-kind production with \'WOW\' effects that transform your gala into an unforgettable evening of elegance and amazement.'
    },
    {
      id: 3,
      icon: 'ri-cake-3-line',
      title: 'Themed Parties',
      description: 'From classic elegance to bespoke international concepts, creating immersive experiences tailored to your vision.'
    },
    {
      id: 4,
      icon: 'ri-trophy-line',
      title: 'Awards Ceremonies',
      description: 'Increasing motivation and honoring status with performances that elevate the prestige of your recognition events.'
    },
    {
      id: 5,
      icon: 'ri-rocket-line',
      title: 'Product Launches',
      description: 'Distinctive moments for a flawless presentation that ensure your product debut is memorable and impactful.'
    },
    {
      id: 6,
      icon: 'ri-vip-crown-line',
      title: 'Hospitality & VIP Programs',
      description: 'Exclusive entertainment for high-profile guests and sport hospitality that delivers sophistication and exclusivity.'
    }
  ];

  return (
    <section className="relative py-32 px-6 bg-zinc-950">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Are you an event planner?
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Specialized entertainment solutions for every type of corporate gathering
          </p>
        </div>

        {/* Expertise Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {expertise.map((item) => (
            <div 
              key={item.id}
              className="group bg-zinc-900 rounded-2xl border border-zinc-800 p-8 hover:border-red-600 hover:shadow-2xl hover:shadow-red-600/10 transition-all duration-500 hover:-translate-y-2"
            >
              <div className="flex items-center justify-center w-16 h-16 rounded-full bg-red-600/10 mb-6 group-hover:bg-red-600/20 transition-colors duration-300">
                <i className={`${item.icon} text-3xl text-red-500`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                {item.title}
              </h3>
              
              <p className="text-gray-400 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}